import { IRuleTableProps } from 'domains/designers/RuleTable/RuleTable';
import { ErrorBoundary } from 'react-error-boundary';
import { renderComponent } from 'utils/RenderingUtils';
import { TruthTableErrorFallback } from '../TruthTable/TruthTableErrorFallback';

export async function renderRuleTable(props: IRuleTableProps, container: HTMLElement, callback?: () => void) {
  const { RuleTable } = await import('domains/designers/RuleTable/RuleTable');

  return renderComponent({
    container,
    component: (
      <ErrorBoundary FallbackComponent={TruthTableErrorFallback}>
        <RuleTable {...props} />
      </ErrorBoundary>
    ),
    callback,
    autoUnmount: true,
  });
}
